import { RAISIN_LIGHT_BLUE_SITE_LOGO, RAISIN_LOGO } from '../../../../constants';
import { comCorporateMenus } from './comCorporateMenus';
export const getCorporateNavigation = (isThemeV2) => {
    const logoUrl = isThemeV2 ? RAISIN_LIGHT_BLUE_SITE_LOGO : RAISIN_LOGO;
    return comCorporateMenus(logoUrl);
};
//# sourceMappingURL=index.js.map